import { startPollingMessages } from './startPollingMessages';
import { IOfferReactionSchema } from '../../repositories/cian-chat-bot/entities/offer_reaction/OfferReactionSchema';
import { chatbotSetOfferReaction } from '../../services/chatbotSetOfferReaction';
import { showAlert } from '../../slices/alertSlice';
import { TThunkAction } from '../../types/redux/thunk';

export const applyOfferReaction =
  (params: IOfferReactionSchema): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const result = await chatbotSetOfferReaction({ httpApi, logger }, params);

    if (!result) {
      dispatch(showAlert({ message: 'Сервисная ошибка. Попробуйте позже.' }));

      return;
    }

    dispatch(startPollingMessages());
  };
